export const Paths = {
  /** Auth Module Module */

  LOGIN: "/",
  OTP: "/otp",
  SUPPORT: "/support",

  HOME: "",

  /** Analytics Module */
  ANALYTICS: "/analytics",

  /** Profile Section */
  MY_PROFILE: "/my-profile",
  EDIT_MY_PROFILE: "/edit-my-profile",
  COMPANY_PROFILE: "/company-profile",
  EDIT_COMPANY_PROFILE: "/edit-company-profile",

  /** Support */
  SUPPORT_PAGE: "/my-support",

  /** Account management  */
  ACCOUNT_LIST: "/account",
  ADD_ACCOUNT: "/account/add",
  ACCOUNT_DETAILS: "/account/details",

  /** Rewards Management */
  REWARDS_MANAGEMENT: "/rewards-management",
  ADD_REWARD: "/rewards-management/add-reward",
  REWARD_DETAIL: "/rewards-management/reward-detail",

  /** api connection */
  API_CONNECTIONS: "/api-connections",
  ADD_INTEGRATION: "/api-connections/add",
  EDIT_INTEGRATION: "/api-connections/edit",
  INTEGRATION_DETAILS: "/api-connections/detail",

  /** Strains */
  STRAINS: "/strains",
  ADD_STRAIN: "/strains/add",
  EDIT_STRAIN: "/strains/edit",
  STRAIN_DETAIL: "/strains/detail",
  UPLOAD_STRAINS: "/strains/upload",
  STRAIN_BATCH_DETAIL: "/strains/batch-detail",

  /** Employees Management */
  EMPLOYEEES_MANAGEMENT: "/employees-management",
  ADD_EMPLOYEES: "/employees-management/add",
  EDIT_EMPLOYEES: "/employees-management/edit",
  EMPLOYEE_DETAIL: "/employees-management/detail",

  /** Announcements */
  ANNOUNCEMENTS: "/announcements",
  ADD_ANNOUNCEMENT: "/announcements/add",
  EDIT_ANNOUNCEMENT: "/announcements/edit",
  ANNOUNCEMENT_DETAIL: "/announcements/detail",

  /** QR code purchasing */
  QR_CODE_PURCHASING: "/qr-code-purchasing",
  SERIAL_NUMBER: "/qr-code-purchasing/serial-number",
  ORDER_DETAIL: "/qr-code-purchasing/serial-number/order-detail",
  SERIAL_NUMBER_DETAIL: "/qr-code-purchasing/serial-number-detail",
  TRANSACTION_DETAIL: "/qr-code-purchasing/transaction-detail",
  PAYMENT_SUCESS: "/qr-code-purchasing/success",

  CART: "/cart",

  /** access denied */
  ACCESS_DENIED: "/access-denied",

  // subscription
  SUBSCRIPTION: "/subscription",
  SELECTED_SUBSCRIPTION: "/selected-subscription",
  MY_SUBSCRIPTION: "/my-subscription",
  BUY_SUBSCRIPTION: "/buy-subscription",

  /** Batches */
  BATCHES: "/batches",
  BATCH: "/batch",
  UPLOAD_BATCHES: "/batches/upload-batches",
  COA_TOKENIZE: "/batches/coa-tokenize",
  PRODUCT_TOKENIZE: "/batches/product-tokenize",
  BATCH_DETAIL: "/batches/detail",
  BATCH_CONSUMERS_DETAIL: "/batches/consumer-batch-detail",
  ALL_BATCHES: "/all-batches",
  ALL_STRAINS: "/all-strains",
  BATCH_STRAIN_DETAIL: "/batches/batch-strain-detail",
  REVIEW_DETAILS: "/batches/review-rating",

  // Notification

  Notification: "/notification",

  CompareStrain: "/analytics/compare",

  /**use not found */
  DETAIL_NOT_FOUND: "/not-found",
  PAGE_NOT_FOUND: "/page-not-found",

  BATCH_BLOCKCHAIN_VIEW: "/batches/blockchain-view",

  CONSUMERS_DETAIL: "/consumers",

  CONSUMERS_MANAGEMENT: "/consumers-management",
  CONSUMERS_MANAGEMENT_DETAIL: "/consumers-management/consumer-detail",
};
